export default {
  isLoading: false,
  memberSince: null,
  numberOfProductBoughtSinceLastUnlock: null,
  numberOfPendingSelectionProducts: null,
  currentSelectedFreeProduct: {
    slug: null,
    // expired_at: null,
  },
  freeProductCatalog: [],
};
